import React from 'react';

import { Container, Paragraph, FooterButton } from './styles';
import Header from '../../components/HeaderMenuContent';
import NaoAprovado from '../../assets/naoAprovado.png';
import {Button} from "react-bootstrap";
import { useNavigate } from 'react-router'

export default function OrderNotApproved() {
    const navigate = useNavigate()
    function RoutesHome () {
        navigate('/loja/orderresume')
    }

    return (
        <>
            <Header />
            <Container>
                <Paragraph>
                    <img src={NaoAprovado } alt="Order" />
                    <p className="title">Pedido não aprovado!</p>
                    <p className="text">Não foi possível processar o seu pedido.<br/> Confira seus dados e tente novamente.</p>
                </Paragraph>
                <FooterButton>
                    <Button onClick={RoutesHome} className="btn-default-wl">VOLTAR</Button>
                </FooterButton>
            </Container>
        </>
    )

}
